export enum OrderCustomFields {
    ORDER_HAS_DISCOUNT = "order_CF_HasDiscount",
    ORDER_DISCOUNTED_PRICE = "order_CF_DiscountedPrice",
    ORDER_PRICE = "order_CF_Price",
    ORDER_DISCOUNT = "order_CF_Discount",
    ORDER_FIRST_NAME = "order_CF_ShopperFirstName",
    ORDER_LAST_NAME = "order_CF_ShopperLastName",
    ORDER_DELIVERY_DATE = "order_CF_DeliveryDate",
    ORDER_DELIVERY_TIME_SLOT = "order_CF_DeliveryTimeSlot",
}

export enum ShippingMethodCustomeFields {
    shippingMethodDeliveryTime = "shippingmethod_CF_DeliveryTime",
    shippingMethodOrderType = "shippingmethod_CF_OrderType",
}
